var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreditionSchriftfarbe2Control(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.55,36H5.66a.64.64,0,0,0,.66-.51L8,30a.31.31,0,0,1,.26-.2H21.73A.31.31,0,0,1,22,30l1.68,5.51a.64.64,0,0,0,.67.51h5.1c.37,0,.56-.15.56-.46a.67.67,0,0,0-.05-.26L18.82.51A.64.64,0,0,0,18.16,0H11.78a.64.64,0,0,0-.66.51L0,35.28a.57.57,0,0,0,0,.54A.57.57,0,0,0,.55,36ZM14.79,7.56c0-.14.09-.2.15-.2s.12.06.16.2l5.25,17.23c.07.21,0,.31-.2.31H9.79c-.17,0-.24-.1-.2-.31Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreditionSchriftfarbe2Control);
export default __webpack_public_path__ + "static/media/tredition-schriftfarbe2-control.e7d929369c7812af3152cbbe8bd5cc7e.svg";
export { ForwardRef as ReactComponent };